import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  static values = {
    turboUrl: String,
  }

  formSubmit() {
    this.formTarget.requestSubmit()
  }

  submitFilter() {
    this.formTarget.action = this.turboUrlValue
    this.formTarget.requestSubmit()
  }
}
